import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "availabilityYearPanel",
    "availabilityRollingPanel",
    "requestYearPanel",
    "requestRollingPanel",
    "yearButton",
    "rollingButton"
  ]
  static values = { period: { type: String, default: "year" } }

  connect() {
    this.showPeriod(this.periodValue)
  }

  showYear() {
    this.periodValue = "year"
    this.showPeriod("year")
  }

  showRolling() {
    this.periodValue = "rolling"
    this.showPeriod("rolling")
  }

  showPeriod(period) {
    const showYear = period === "year"

    this.togglePanel(this.availabilityYearPanelTarget, this.availabilityRollingPanelTarget, showYear)
    this.togglePanel(this.requestYearPanelTarget, this.requestRollingPanelTarget, showYear)
    this.updateButtons()
  }

  togglePanel(yearPanel, rollingPanel, showYear) {
    yearPanel.classList.toggle("hidden", !showYear)
    rollingPanel.classList.toggle("hidden", showYear)

    this.redrawChartsIn(showYear ? yearPanel : rollingPanel)
  }

  redrawChartsIn(panel) {
    panel.querySelectorAll("canvas").forEach((canvas) => {
      const chart = window.Chartkick?.charts?.[canvas.id]
      chart?.redraw?.()
    })
  }

  updateButtons() {
    const activeClasses = ["bg-gray-900", "text-white"]
    const inactiveClasses = ["bg-white", "text-gray-700", "hover:bg-gray-50"]
    const showYear = this.periodValue === "year"

    this.yearButtonTargets.forEach((button) => {
      this.toggleButton(button, showYear, activeClasses, inactiveClasses)
    })
    this.rollingButtonTargets.forEach((button) => {
      this.toggleButton(button, !showYear, activeClasses, inactiveClasses)
    })
  }

  toggleButton(button, active, activeClasses, inactiveClasses) {
    ;[...activeClasses, ...inactiveClasses].forEach((className) => button.classList.remove(className))
    button.classList.add(...(active ? activeClasses : inactiveClasses))
  }
}
